import { render, staticRenderFns } from "./BlackGoldLoginModal.vue?vue&type=template&id=0f27f2c7"
import script from "./BlackGoldLoginModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports